import { render, staticRenderFns } from "./DashboardFiltersV2Item.vue?vue&type=template&id=49ffae42&functional=true"
import script from "./DashboardFiltersV2Item.vue?vue&type=script&lang=js"
export * from "./DashboardFiltersV2Item.vue?vue&type=script&lang=js"
import style0 from "./DashboardFiltersV2Item.vue?vue&type=style&index=0&id=49ffae42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports